import { useContext, useEffect } from 'react';

import { Form } from '../../../../../../../../../shared/components';
import { ModalDeleteTab, QuotationStepButtons } from '../../../../../shared';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import QuotationService from '../../../../../../../../../shared/services/quotation';

import {
  GenericDataFormContext,
  QuotationInfoContext,
} from '../../../../../shared/contexts';
import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

import { FeatureRisk } from '../../../../../../../../../shared/interfaces';
import { QuotationStep } from '../../../../../shared/interfaces';

export const PropertyDataFire = () => {
  const {
    activeKey,
    addNewTab,
    allFeatures,
    fireFormValues,
    keyTabToDelete,
    removeTab,
    setActiveKey,
    setFireFormValues,
    setKeyTabToDelete,
    setShowModal,
    showModal,
    stepThreeForm,
    tabs,
  } = useContext(StepThreeFormContext);
  const { quotationForm, handleTabErrors } = useContext(WizardDataFormContext);
  const { setCanShowSpinner, setUserCanDeleteTabs } = useContext(GenericDataFormContext);
  const { setCurrentStep, quotationInfo, loadSaveQuotationState } = useContext(QuotationInfoContext);

  const validateFeatures = () => {
    return new Promise(async (resolve, reject) => {
      let hasError = false;

      try {
        for (const { key } of tabs) {
          const featureList: FeatureRisk[] = [];
          const featuresFiltered = allFeatures
            .filter((feature) => feature.keyTab === key)
            .map(({ features }) => features);

          featuresFiltered.forEach((featureGroup) => {
            featureGroup.forEach(({ codigo }) => {
              const fieldName = `feature-tab-${key}-${codigo}`;
              const fieldValue = stepThreeForm?.getFieldValue(fieldName);
              const alreadyExists = featureList.some(
                (feature) => feature.codigo === codigo
              );

              if (!alreadyExists) {
                featureList.push({
                  codigo,
                  valor: fieldValue,
                });
              }
            });
          });

          const params = {
            numeroCotizacion: Number(quotationInfo?.token),
            rama: Number(quotationInfo?.branch),
            componente: key,
            codigoPostal: Number(quotationForm?.cliente?.codigoPostal),
            sufijoPostal: Number(quotationForm?.cliente?.sufijoCodigoPostal),
            caracteristicas: featureList,
          };

          if (!hasError) {
            try {
              await QuotationService.postValidateFeaturesRiskVarious(params);
            } catch (error) {
              hasError = true;
              reject(new Error('An error occurred during validation'));
              return;
            }
          }
        }

        resolve('');
      } catch (error) {
        reject(new Error(''));
      }
    });
  };

  const onValidateForm = async () => {
    try {
      setCanShowSpinner(true);

      await stepThreeForm?.validateFields();

      await validateFeatures();

      setFireFormValues(stepThreeForm?.getFieldsValue());
      setUserCanDeleteTabs(false);
      setCurrentStep(QuotationStep.FOUR);
    } catch (error: any) {
      if (error && error?.errorFields?.length > 0) {
        handleTabErrors(error?.errorFields, ['tab'], 'Incendio Web');
      }
    } finally {
      setCanShowSpinner(false);
    }
  };

  const onChange = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  const onEdit = (targetKey: any, action: 'add' | 'remove') => {
    if (action === 'add') {
      addNewTab();

      return;
    }

    setShowModal(true);
  };

  const handlerBackButton = () => {
    setFireFormValues(stepThreeForm?.getFieldsValue());
    setCurrentStep(QuotationStep.TWO);
  };

  const handleOk = () => {
    if (keyTabToDelete !== null) {
      removeTab(keyTabToDelete);
      setKeyTabToDelete(null);
    }

    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    setKeyTabToDelete(null);
  };

  useEffect(() => {
    if (!loadSaveQuotationState && fireFormValues && Object.keys(fireFormValues).length > 0) {
      stepThreeForm?.setFieldsValue(fireFormValues);
    }
  }, [loadSaveQuotationState, fireFormValues, stepThreeForm]);

  return (
    <>
      <Form
        formProps={{
          form: stepThreeForm,
          name: 'property-data-fire-form',
        }}
      >
        <Tabs
          type='editable-card'
          activeKey={activeKey}
          onEdit={onEdit}
          hideAdd={false}
          items={tabs}
          handlePressTab={onChange}
        />

        <QuotationStepButtons
          label='Continuar'
          onClick={onValidateForm}
          onPressBackButton={handlerBackButton}
        />
      </Form>

      <ModalDeleteTab
        open={showModal}
        onCancel={handleCancel}
        onOk={handleOk}
      />
    </>
  );
};
